import { OpaccFormElementDateTimePicker } from './opacc.class.form.element.datetimepicker.js';

/** @module form */

/**
 * Funktionalität zur Kalenderanzeige / Auswahl eines Datums aus einem Kalender
 *
 * @extends {OpaccFormElementDateTimePicker}
 */
export class OpaccFormElementDatePicker extends OpaccFormElementDateTimePicker {
	constructor(customSettings = null, wrapper = null) {
		super();
		this.wrapperElement = wrapper || document.querySelector('body');
		this.datePickerWrapperSelector = '.opc-date';
		this.datePickerFields = this.wrapperElement.querySelectorAll(`${this.datePickerWrapperSelector}`);

		this.initDatePicker(customSettings);
	}

	/**
	 *
	 *
	 * @param {*} dateFormat
	 * @param {*} separator
	 * @returns {*}
	 */
	dateFormatMapping(dateFormat, separator) {
		if (!dateFormat || !separator) {
			return 'd.m.Y';
		}

		let mappedDate = dateFormat.toLowerCase().split('.').map(item => {
			let datePart = item.charAt(0);
			return datePart == 'y' ? datePart.toUpperCase() : datePart;
		});
		return mappedDate.join(separator);
	}

	/**
	 *
	 *
	 * @param {*} customSettings
	 */
	initDatePicker(customSettings) {
		Array.from(this.datePickerFields).forEach(item => {
			let inputField = item.querySelector('input[type="text"]');
			let currentDateFormat = inputField.dataset.opDateFormat || null;
			let currentDateSeparator = inputField.dataset.opDateSeparator || null;
			let currentLang = inputField.dataset.opLang || null;

			const defaultSettings = {
				dateFormat: 'd.m.Y',
				altFormat: this.dateFormatMapping(currentDateFormat, currentDateSeparator),
				altInput: true,
				locale: this.getLocale(currentLang),
				appendTo: item,
				disableMobile: true,
				allowInput: true,
				weekNumbers: true,
				monthSelectorType: 'dropdown',
                static: true
			};

			if (customSettings) {
				if (typeof customSettings != 'object') {
					throw new Error ('inputparameter must be an Object!');
				}
			}

			let settings = Object.assign(defaultSettings, customSettings);
			this.createDatePicker(inputField, settings);
		});
	}

	/**
	 *
	 *
	 * @param {*} inputField
	 * @param {*} config
	 */
	createDatePicker(inputField ,config) {
		this.datePicker = this.createDateTimePicker(inputField, config);
		this.triggerDatePickerEvents();
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	triggerDatePickerEvents() {
		return this.triggerDateTimePickerEvents(this.datePicker);
	}
}